
;
(function ($) {

    // Scripts which runs after DOM load

    $(document).ready(function () {

        const scrollToTitle = () => {
            $('.js-title-scroll').on('click', function () {
                var dataTitle = $(this).data('title');
                var scrollToElement = $('[data-scroll="' + dataTitle + '"]');
                if (scrollToElement.length) {
                    $('html, body').animate({
                        scrollTop: scrollToElement.offset().top - 30
                    }, 1000); // You can adjust the speed (in milliseconds) of the smooth scroll here
                }
            });
        }
        scrollToTitle();


        const postFilterAndLoadMore = () => {
            // Initial settings
            var currentPage = 1;
            var postsPerPage = 4;
            var categoryFilter = 'all';
            var $postList = $('.js-post-list-ajax-reload');


            // Function to load posts via AJAX
            function loadPosts() {
                $.ajax({
                    // url: wc_cart_params.ajax_url,
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    dataType: 'html',
                    data: {
                        action: 'load_posts',
                        page: currentPage,
                        per_page: postsPerPage,
                        category: categoryFilter
                    },
                    success: function (response) {
                        if ($('.js-post-category-filter-ajax').hasClass('category-filter-list__item--active')) {
                            $postList.append(response);
                        } else {
                            $postList.html(response);
                        }
                        // Check if there are more posts to load
                        if ($(response).length < postsPerPage) {
                            $('.js-bottom').hide();
                        } else {
                            $('.js-bottom').show();
                        }
                    }
                });
            }

            // Filter posts by category when a filter item is clicked
            $('.js-post-category-filter-ajax').on('click', function () {
                var $clickedItem = $(this);
                // Remove the active class from the current active item
                $('.js-post-category-filter-ajax.category-filter-list__item--active').removeClass('category-filter-list__item--active');

                // Add the active class to the clicked item
                $clickedItem.addClass('category-filter-list__item--active');
                categoryFilter = $(this).data('slug');
                currentPage = 1;
                $postList.empty();
                loadPosts();
            });

            // Load more posts when the "View more" button is clicked
            $('.js-load-more-posts-ajax').on('click', function () {
                currentPage++;
                loadPosts();
            });
        }

        postFilterAndLoadMore();

        const termsSidebar = () => {

            // Find all h1-h6 tags inside .js-term-content
            var content = $('.js-term-content');
            // Check if any titles were found
            if (content.length === 0) {
                return; // Return early if there are no titles
            }
            var titles = content.find('h1, h2, h3, h4, h5, h6');
            // Check if any titles were found
            if (titles.length === 0) {
                return; // Return early if there are no titles
            }

            // Create a new unordered list
            var ul = $('<ul class="terms-and-conditions__list" >');

            // Iterate over the titles and create list items
            titles.each(function (index) {
                var titleText = $(this).text();
                var listItem = $('<li>').text(titleText);

                // Smooth scroll to the corresponding title
                listItem.on('click', function () {
                    var targetTitle = titles.eq(index);
                    $('html, body').animate({
                        scrollTop: targetTitle.offset().top - 30
                    }, 500);
                });

                ul.append(listItem);
            });

            // Append the generated ul to .js-terms-sidebar
            var sidebar = $('.js-terms-sidebar');
            if (sidebar.length === 0) {
                return; // Return early if there are no titles
            }
            sidebar.append(ul);

            // Slide down the generated ul when .js-show-content-titles is clicked
            $('.js-show-content-titles').on('click', function () {
                $(this).toggleClass('terms-and-conditions__sub-title--active');
                ul.slideToggle();
            });
        }

        termsSidebar();


        const openSubMenuMobile = () => {

            var openSubmenu = $('.open-submenu');

            if (!openSubmenu.length) {
                return
            }

            openSubmenu.click(function () {
                var parentMenuItem = $(this).parent('.menu-item');
                var submenu = $(this).next('.header__menu-submenu');

                $(this).toggleClass('open-submenu--active');

                if (parentMenuItem.hasClass('active')) {
                    parentMenuItem.removeClass('active');
                    submenu.slideUp();
                } else {
                    parentMenuItem.addClass('active');
                    submenu.slideDown();
                }
            });
        }

        openSubMenuMobile();

        const toggleSearchClass = () => {
            // Check if elements exist
            const mobileSearchElements = document.querySelectorAll('.js-mobile-search');
            const searchElement = document.querySelector('.header__search');

            if (mobileSearchElements.length === 0 || !searchElement) {
                return; // Elements don't exist, so return
            }

            // Toggle class on click
            mobileSearchElements.forEach((mobileSearchElement) => {
                mobileSearchElement.addEventListener('click', function () {
                    searchElement.classList.toggle('header__search--active');
                });
            });
        }
        toggleSearchClass();

        const updateCart = () => {

            var timeout;

            $('div.woocommerce').on('change keyup mouseup', 'input.qty', function () { // keyup and mouseup for Firefox support
                if (timeout != undefined) clearTimeout(timeout); //cancel previously scheduled event
                if ($(this).val() == '') return; //qty empty, instead of removing item from cart, do nothing
                timeout = setTimeout(function () {
                    $('[name="update_cart"]').trigger('click');
                }, 1000);
            });

        }
        updateCart();

        const heroSlider = () => {

            var heroSlider = $('.js-hero-slider');

            if (heroSlider.length <= 0) {
                return;
            }

            const swiper = new Swiper('.js-hero-slider', {
                // Optional parameters
                loop: true,
                grabCursor: true,
                autoplay: {
                    delay: 7000,
                },

                // Navigation arrows
                navigation: {
                    nextEl: ".js-button-next",
                    prevEl: ".js-button-prev",
                },

                // If we need pagination
                pagination: {
                    el: ".js-swiper-pagination",
                    clickable: true,
                },

            });
        }
        heroSlider();

        const categorySlider = () => {

            var categorySlider = $('.js-category-slider');

            if (categorySlider.length <= 0) {
                return;
            }

            const swiper = new Swiper('.js-category-slider', {
                // Optional parameters
                autoplay: {
                    delay: 7000,
                },
                slidesPerView: "auto",
                spaceBetween: 20,

                // Navigation arrows
                navigation: {
                    nextEl: ".js-button-next",
                    prevEl: ".js-button-prev",
                },

                breakpoints: {
                    "600": {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    "768": {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    "992": {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    "1440": {
                        slidesPerView: 5,
                        spaceBetween: 30,
                    },
                },

            });
        }
        categorySlider();


        const featuredSlider = () => {

            var featuredSlider = $('.js-featured-products');

            if (featuredSlider.length <= 0) {
                return;
            }

            const swiper = new Swiper('.js-featured-products', {
                autoplay: {
                    delay: 7000,
                },
                effect: "coverflow",
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "auto",
                preventClicks: false,
                loop: true,
                preventClicksPropagation: false,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 100,
                    depth: 250,
                    modifier: 1,
                    slideShadows: true
                },

                breakpoints: {
                    "768": {
                        coverflowEffect: {
                            stretch: 150,
                            depth: 250,
                        },
                    },
                    "1200": {
                        coverflowEffect: {
                            stretch: 400,
                            depth: 250,
                        },
                    },
                },

                // If we need pagination
                pagination: {
                    el: ".js-swiper-pagination",
                    clickable: true,
                },

            });
        }
        featuredSlider();

        const customSelect = () => {

            var customSelect = $('.js-custom-orderby, .variations select , .woocommerce-ordering .orderby');

            if (customSelect.length <= 0) {
                return;
            }

            customSelect.selectWoo();
        }
        customSelect();

        const validateCommentForm = () => {
            const form = document.getElementById('commentform');

            if (!form) {
                return;
            }

            const elements = form.elements;

            // Create error message div for each input field
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                if (element.type !== 'submit' && element.type !== 'checkbox') {
                    const errorMessage = document.createElement('div');
                    errorMessage.id = `${element.id}-error-message`;
                    errorMessage.className = 'error-message';
                    element.parentNode.insertBefore(errorMessage, element.nextSibling);
                }
            }

            // Validation function
            function validateForm() {
                let valid = true;

                // Validate rating input
                const ratingInput = document.getElementById('rating');
                const ratingErrorMessage = document.getElementById('rating-error-message');

                if (ratingInput) {
                    if (ratingInput.value === '') {
                        ratingErrorMessage.textContent = 'Please select a rating';
                        valid = false;
                    } else {
                        ratingErrorMessage.textContent = '';
                    }
                }

                // Validate comment input
                const commentInput = document.getElementById('comment');
                const commentErrorMessage = document.getElementById('comment-error-message');
                if (commentInput) {
                    if (commentInput.value === '') {
                        commentErrorMessage.textContent = 'Please enter your review';
                        valid = false;
                    } else {
                        commentErrorMessage.textContent = '';
                    }
                }

                // Validate author input
                const authorInput = document.getElementById('author');
                const authorErrorMessage = document.getElementById('author-error-message');
                if (authorInput) {
                    if (authorInput.value === '') {
                        authorErrorMessage.textContent = 'Please enter your name';
                        valid = false;
                    } else {
                        authorErrorMessage.textContent = '';
                    }
                }

                // Validate email input
                const emailInput = document.getElementById('email');
                const emailErrorMessage = document.getElementById('email-error-message');
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (emailInput) {
                    if (!emailPattern.test(emailInput.value)) {
                        emailErrorMessage.textContent = 'Please enter a valid email address';
                        valid = false;
                    } else {
                        emailErrorMessage.textContent = '';
                    }
                }

                return valid;
            }

            // Add form submission event listener
            form.addEventListener('submit', function (event) {
                if (!validateForm()) {
                    event.preventDefault();
                }
            });
        }

        validateCommentForm();

        const toggleLoginForm = () => {

            var loginForm = document.querySelector('.cart-login__form');

            if (!loginForm) {
                return;
            }

            var loginButton = document.querySelector('.js-login-btn');
            var guestButton = document.querySelector('.js-guest');

            const clickHandler = (element1, element2) => {
                element1.classList.add('custom-btn--blue');
                element1.classList.remove('custom-btn--blue-transparent');
                element2.classList.remove('custom-btn--blue');
                element2.classList.add('custom-btn--blue-transparent');
            }

            loginButton.addEventListener('click', () => {
                loginForm.style.display = 'block';
                clickHandler(loginButton, guestButton);
            });

            guestButton.addEventListener('click', () => {
                loginForm.style.display = 'none';
                clickHandler(guestButton, loginButton);
            });
        }

        toggleLoginForm();


        const modifyRadio = () => {
            const formElement = document.querySelector('.woocommerce-EditAccountForm');

            if (!formElement) {
                return;
            }

            const selector = '[for^="mailchimp_woocommerce_"]';
            const elements = document.querySelectorAll(selector);

            if (elements.length === 0) {
                return;
            }

            elements.forEach(element => {
                var parentElement = element.parentElement;
                var inputElement = element.querySelector('input');

                if (!parentElement && !inputElement) {
                    return;
                }

                parentElement.insertBefore(inputElement, parentElement.firstChild);

            });
        }

        modifyRadio();

        const toggleFilter = () => {

            var filterLists = document.querySelector('.sidebar-filter__lists')
            var showFilterButton = document.querySelector('.js-show-filter');
            var closeFilterButton = document.querySelector('.js-close-filter');

            if (!filterLists || !showFilterButton || !closeFilterButton) {
                return;
            }

            showFilterButton.addEventListener('click', function () {
                filterLists.classList.add('sidebar-filter__lists--active');
            });

            closeFilterButton.addEventListener('click', function () {
                filterLists.classList.remove('sidebar-filter__lists--active');
            });
        }

        toggleFilter();

        const toggleFilterList = () => {

            var filterTitles = document.querySelectorAll('.js-filter-title');

            if (filterTitles.length <= 0) {
                return
            }

            filterTitles.forEach(function (filterTitle) {
                filterTitle.addEventListener('click', function () {
                    var filterList = this.nextElementSibling;
                    if (filterList) {
                        filterList.classList.toggle('attribute-filter__list--active');
                    }
                    this.classList.toggle('attribute-filter__title--active');
                });
            });
        }

        toggleFilterList();


        const hideHeaderTop = () => {

            var headerClose = document.querySelector('.js-header-close');

            if (!headerClose) {
                return
            }

            headerClose.addEventListener('click', hideHeader);

            function hideHeader() {

                var headerTop = document.querySelector('.js-header-top');

                if (!headerTop) {
                    return
                }

                headerTop.style.display = 'none';
            }
        }

        hideHeaderTop();

    });

    // FAQ Spollers 

    function faqsSpollers() {
        if (document.querySelector('.faqs__columns')) {
            const faqColumns = document.querySelectorAll('.faqs__column');

            faqColumns.forEach((item) => {
                item.addEventListener('click', (event) => {
                    let target = event.target;
                    if (target.classList.contains('faqs-item__title')) {
                        let colItems = target.closest('.faqs__column').querySelectorAll('.faqs-item');
                        target.closest('.faqs-item').classList.toggle('active');

                        colItems.forEach((item) => {
                            if (item != target.closest('.faqs-item')) {
                                item.classList.remove('active');
                            }
                        });
                    }
                });
            });
        }
    }

    // FAQ Search
    function faqSearch() {

        let faqItems = document.querySelectorAll('.faqs-item');
        const searchInput = document.querySelector('#faq-search');

        function faqSearching() {
            let searchVal = searchInput.value;
            let result = [];
            // Change input class 
            if (searchVal !== '') {
                searchInput.closest('.faqs__search').classList.add('search-active');
            } else {
                searchInput.closest('.faqs__search').classList.remove('search-active');
            }

            // Searching
            let faqLowerCaseSearch = (string, value) => {
                if (string && value) {
                    let strLow = string.toLowerCase();
                    let valLow = value.toLowerCase();

                    if (strLow.search(valLow) === -1) {
                        return false;
                    } else {
                        return true;
                    }
                } else if (value === '') {
                    return true;
                }
                return;
            };

            faqItems.forEach((item, index) => {
                let title = item.querySelector('.faqs-item__title').innerText;
                let content = item.querySelector('.faqs-item__content').innerText;

                if (faqLowerCaseSearch(title, searchVal)) {
                    result.push(index);
                } else if (faqLowerCaseSearch(content, searchVal)) {
                    result.push(index);
                }
            });


            // Show results
            faqItems.forEach((item, index) => {
                if (!result.includes(index)) {
                    item.style.display = "none";
                } else {
                    item.style.display = "block";
                }
            });
        }

        // Call searching on events 
        if (faqItems && searchInput) {
            searchInput.addEventListener('change', (event) => {
                faqSearching();
            });

            searchInput.addEventListener('input', (event) => {
                faqSearching();
            });
        }
    }

    // *Dealer locator functions

    // *Dealer locator svg map

    function dealerLocatorSvgMap() {
        let wordStates = document.querySelectorAll(".dealer-locator-filter__list li");
        let svgStates = document.querySelectorAll("#states > *");

        function removeAllOn() {
            wordStates.forEach(function (el) {
                el.classList.remove("on");
            });
            svgStates.forEach(function (el) {
                el.classList.remove("on");
            });
        }

        function addOnFromList(el) {
            let stateCode = el.getAttribute("data-state");
            let svgState = document.querySelector("#" + stateCode);
            el.classList.add("on");
            svgState.classList.add("on");
        }

        function addOnFromState(el) {
            let stateId = el.getAttribute("id");
            let wordState = document.querySelector("[data-state='" + stateId + "']");
            el.classList.add("on");

            if (wordState) {
                wordState.classList.add("on");
            }
        }

        function locationFromSvg(el) {
            let stateId = el.getAttribute("id");
            let wordState = document.querySelector("[data-state='" + stateId + "'] a");
            let itemUrl = wordState.getAttribute("href");
            window.location.href = itemUrl;
        }


        wordStates.forEach(function (el) {
            el.addEventListener("mouseenter", () => {
                addOnFromList(el);
            });
            el.addEventListener("mouseleave", () => {
                removeAllOn();
            });

            el.addEventListener("touchstart", () => {
                removeAllOn();
                addOnFromList(el);
            });
        });

        svgStates.forEach(function (el) {
            el.addEventListener("mouseenter", () => {
                addOnFromState(el);
            });
            el.addEventListener("mouseleave", () => {
                removeAllOn();
            });

            el.addEventListener("touchstart", () => {
                removeAllOn();
                addOnFromState(el);
            });

            el.addEventListener("click", () => {
                locationFromSvg(el);
            })
        });
    }

    // *Dealer locator filter

    function dealerShowAvailableFromList() {
        let stateList = document.querySelectorAll(".dealer-locator-filter__list li");
        let switchInputs = document.querySelectorAll("[name='dealer-switch']");


        function hideEmpty() {
            stateList.forEach((el) => {
                if (!el.getAttribute('data-count')) {
                    el.style.display = "none";
                }
            });
        }

        function showAll() {
            stateList.forEach((el) => {
                el.style.display = "block";
            });
        }

        switchInputs.forEach((el) => {
            el.addEventListener('click', (event) => {
                let target = event.target;
                if (target.getAttribute('id') === 'dealer-all') {
                    showAll();
                } else {
                    hideEmpty();
                }

            });
        });
    }

    // *Dealer Locator Search from list

    function dealerLocatorSearch() {

        let stateList = document.querySelectorAll('.dealer-locator-filter__link');
        const searchInput = document.querySelector('#dealer-locator-search');

        function hide(el) {
            el.style.display = "none";
        }

        function show(el) {
            el.style.display = "inline-block";
        }


        function search() {
            stateList.forEach((item) => {
                let itemText = item.innerText.toLowerCase();
                let searchVal = searchInput.value.toLowerCase();

                if (itemText.search(searchVal) === -1) {
                    hide(item.closest('.dealer-locator-filter__item'));
                } else {
                    show(item.closest('.dealer-locator-filter__item'));
                }
            });
        }

        // *Call searching on events 
        if (stateList && searchInput) {
            searchInput.addEventListener('change', (event) => {
                search();
            });

            searchInput.addEventListener('input', (event) => {
                search();
            });
        }
    }

    // *Dealer locator mobile dropdown

    function dealerMobileDropdown() {
        let dropBtn = document.querySelector('.dealer-locator-filter__dropdown-label');
        let dropBody = document.querySelector('.dealer-locator-filter__dropdown');

        if (dropBtn && dropBody) {
            dropBtn.addEventListener('click', (event) => {
                dropBtn.classList.toggle('active');
                dropBody.classList.toggle('show');
            });
        }
    }

    // *Dealer add count on map

    function addStatesCountOnMap() {
        let stateList = document.querySelectorAll(".dealer-locator-filter__list li");
        let svgGroup = document.querySelector('.svg-states g');

        if (stateList && svgGroup) {
            let svgRect = svgGroup.getBBox();
            let result = '';

            stateList.forEach((item) => {
                let itemCount = item.getAttribute("data-count");

                if (itemCount) {
                    let itemID = item.getAttribute("data-state");
                    let svgPath = document.querySelector("#" + itemID);
                    let pathRect = svgPath.getBBox();
                    let centreX = pathRect.x - svgRect.x + (pathRect.width / 2);
                    let centreY = pathRect.y - svgRect.y + (pathRect.height / 2) + 12;
                    let child = '<text x="' + centreX + '" y="' + centreY + '" class="dealer-number">' + itemCount + '</text>';

                    result += child;
                }
            });
            svgGroup.insertAdjacentHTML('beforeend', result);
        }
    }


    // *Dealer locator Single Page show dealer on a map

    function dealerSingleShowMap() {
        let dealerItems = document.querySelectorAll('.delaers-list__item');
        let iframe = document.querySelector('.dealer-locator-single__map iframe');

        function showOnMap(el) {
            let mapUrl = el.getAttribute('data-map');

            if (iframe && mapUrl) {
                iframe.setAttribute('src', mapUrl)
            }
        }

        if (dealerItems) {
            dealerItems.forEach((el) => {
                el.addEventListener('click', () => {
                    showOnMap(el);
                });

                el.addEventListener('mouseenter', () => {
                    showOnMap(el);
                });
            });
        }
    }

    // *Call functions after DOM load
    window.addEventListener('DOMContentLoaded', () => {
        faqsSpollers();
        faqSearch();
        dealerLocatorSvgMap();
        dealerShowAvailableFromList();
        dealerLocatorSearch();
        dealerMobileDropdown();
        addStatesCountOnMap();
        dealerSingleShowMap();
    })


    // Scripts which runs after all elements load

    $(window).on('load', function () {

        const scrollThumbnail = () => {
            // Get the element that contains the scrollable content
            var container = document.querySelector('.flex-control-thumbs');

            if (!container) {
                return;
            }

            var isDragging = false;
            var startPosition = 0;
            var startScrollPosition = 0;

            container.addEventListener('mousedown', function (event) {
                // Check if the scroll bar is hidden
                if (container.scrollHeight <= container.clientHeight) {
                    isDragging = true;
                    startPosition = event.clientY;
                    startScrollPosition = container.scrollTop;
                }
            });

            document.addEventListener('mousemove', function (event) {
                if (isDragging) {
                    var deltaY = event.clientY - startPosition;
                    container.scrollTop = startScrollPosition - deltaY;
                }
            });

            document.addEventListener('mouseup', function () {
                isDragging = false;
            });

        }

        scrollThumbnail();
    });

    // Scripts which runs at window resize

    $(window).resize(function () {

        //jQuery code goes here

    });

}(jQuery));


